module.exports = __webpack_public_path__ + "static/img/assist.63efc74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/assist.svg
// module id = QDUN
// module chunks = 94